module.exports = __webpack_public_path__ + "img/tap-icon.18cc1208.svg";